import { useEffect, useRef, type ReactNode } from "react";

interface DialogProps {
  title: string;
  children: ReactNode;
  onClose(): void;
}

export function Dialog({ title, children, onClose }: DialogProps) {
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const previouslyFocused = document.activeElement;
    const firstControl = dialogRef.current?.querySelector<HTMLElement>("input, select, textarea, button");
    firstControl?.focus();
    return () => {
      if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus();
    };
  }, []);

  return (
    <div
      className="overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        ref={dialogRef}
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            event.stopPropagation();
            onClose();
          }
        }}
      >
        <div className="dialog-body">
          <h2>{title}</h2>
          {children}
        </div>
      </div>
    </div>
  );
}
